

























































































































































import { Component, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeaderMain from "@/components/AppHeader/AppHeaderMain.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";

import RequestState from "@/utils/mixins/RequestState";
import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import {
  IKnowledgeBase,
  IKnowledgeBaseListItem
} from "@/models/interfaces/knowledge-base";
import amplitude from "amplitude-js";

@Component({
  components: {
    AppContent,
    AppHeaderMain,
    AppHeader,

    BaseSpinner,
    BaseAlert
  },
  mixins: [RequestState]
})
export default class KnowledgeBase extends Mixins(RequestState) {
  @State("knowledgeBase", { namespace: "knowledgeBase" })
  private knowledgeBase!: IVuexState<IKnowledgeBase[]>;

  @Action("knowledgeBase/fetchKnowledgeBase")
  private fetchKnowledgeBase!: () => IKnowledgeBase[];

  private handleAnalytics({ title, type }: IKnowledgeBaseListItem) {
    amplitude
      .getInstance()
      .logEvent(`User clicks on ${title} (${type}) in knowledge base`);
  }

  private get columns() {
    const staticContent = [
      {
        color: "#88c23f",
        contentColor: "#C4E1A0"
      },
      {
        color: "#e90c6e",
        contentColor: "#F486B8",
        title: "Course structure"
      },
      {
        color: "#f4aa45",
        contentColor: "#F9D4A4"
      }
    ];

    return (
      this.knowledgeBase.data?.map((item, idx) => ({
        ...item,
        ...staticContent[idx]
      })) ?? []
    );
  }

  public mounted() {
    this.fetchKnowledgeBase();
  }
}
